import { useState, useCallback } from 'react';

export const useIsListBoxOpen = (): {
  isListBoxOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
} => {
  const [isListBoxOpen, setIsListBoxOpen] = useState<boolean>(false);

  const toggle = useCallback(() => {
    setIsListBoxOpen((current) => !current);
  }, []);

  const open = useCallback(() => {
    setIsListBoxOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsListBoxOpen(false);
  }, []);

  return { isListBoxOpen, toggle, open, close };
};
